import { IAssetReferenceValue } from '../../types/damTypes';

export function normalizeAssetReferenceValues(value: any): IAssetReferenceValue[] {
  const items = Array.isArray(value)
    ? value
    : value && typeof value === 'object'
      ? [value]
      : [];

  return items
    .map((item) => {
      if (!item || typeof item !== 'object') return null;

      const assetId = String(item.assetId || item._id || item.id || '').trim();
      if (!assetId) return null;

      const labelSnapshot = String(item.labelSnapshot || item.label || item.title || '').trim();
      const subtitleSnapshot = String(item.subtitleSnapshot || item.subtitle || '').trim();

      return {
        assetId,
        labelSnapshot,
        ...(subtitleSnapshot ? { subtitleSnapshot } : {}),
      } as IAssetReferenceValue;
    })
    .filter((item): item is IAssetReferenceValue => item !== null);
}

export function formatAssetReferenceLabels(value: any, emptyValue: string = '—'): string {
  const labels = normalizeAssetReferenceValues(value)
    .map((item) => String(item.labelSnapshot || '').trim())
    .filter(Boolean);

  return labels.length ? labels.join(', ') : emptyValue;
}
